require("../../vendor/jquery.autocomplete.min");
require("sweetalert");

$(document).ready(function() {

	$(".box.active:not(.locked) .box__box-title").on("click", function () {
		$(this).parents(".box").toggleClass("subscriptions-box-closed");
	});

	/*
	 * Auto Scroll to open section
	 */
	if ($(".race-subscribe-steps-container").length) {

		if ($(".login-box").length == 0 && $(".box").length > 0) {

			var scroll_to_target;

			if( $(".box:not(.subscriptions-box-closed)").length ) {

				scroll_to_target = $(".box:not(.subscriptions-box-closed)").position().top;

				if( $(".box:not(.subscriptions-box-closed) .scroll_to_sub_section").length ) {
					scroll_to_target = $(".box:not(.subscriptions-box-closed) .scroll_to_sub_section").position().top;
				}

			}

			$("html, body").animate(
				{ scrollTop: scroll_to_target},
				300
			);
		}
	}

	/*
	 * Populate form from card number
	 */
	function autoCompletePersonlData(racer_card_number) {
		$.get(
			APP_ROOT + "/api/" + LOCALE + "/v1/racers-cards/search",
			{
				racer_card_number: racer_card_number
			},
			function(racer_card) {
				console.log(racer_card)
				if (racer_card) {
					$("#racer_card_number").addClass("card-found");
					$("#racer_card_number").removeClass("card-not-found");

					if (racer_card.name.length) $("#name").val(racer_card.name);
					if (racer_card.surname.length) $("#surname").val(racer_card.surname);
					if (racer_card.birth_date.length) {
						$("#birth_date_day").val(racer_card.birth_date_day);
						$("#birth_date_month").val(racer_card.birth_date_month);
						$("#birth_date_year").val(racer_card.birth_date_year);
					}
					if (racer_card.gender.length > 0) {
						$("#gender").val(racer_card.gender.toLowerCase());
					}

					$("#team_name_non_ita").prop("disabled", true);


					if (racer_card.last_subscription) {

						if (racer_card.last_subscription.fiscal_code)
							$("#fiscal_code").val(racer_card.last_subscription.fiscal_code);

						if (racer_card.last_subscription.address)
							$("#address").val(racer_card.last_subscription.address);

						if (racer_card.last_subscription.city)
							$("#city").val(racer_card.last_subscription.city);

						if (racer_card.last_subscription.state)
							$("#state").val(racer_card.last_subscription.state);

						if (racer_card.last_subscription.postal_code)
							$("#postal_code").val(racer_card.last_subscription.postal_code);

						if (racer_card.last_subscription.country)
							$("#country").val(racer_card.last_subscription.country);

						if (racer_card.last_subscription.phone_number)
							$("#phone_number").val(racer_card.last_subscription.phone_number);

						if (racer_card.last_subscription.email)
							$("#subscribe_email").val(racer_card.last_subscription.email);
					}

					if (typeof racer_card.team !== "undefined") {
						$(".italian-team").addClass("visible");
						$("#team_group").val(racer_card.team.team_group);
						$("#team_name_ita").val(racer_card.team.team_name);
						$("#team_code").val(racer_card.team_code);
						$("#nationality").val("IT");
					}

					displayTeamForm();

				} else {

					console.log('not found')

					$("#racer_card_number").addClass("card-not-found");
					$(".alert-card-not-found").addClass('visible');

				}

			},
			"json"
		);
	}

	// disabilita form submission schicciando enter
	$(document).on("keydown", "form", function(event) {
    	return event.keyCode != 13;
	});

	$(".search-card-code").click( (evt) => {
		
		evt.preventDefault();
		
		$("#racer_card_number").removeClass();
		
		if ($("#racer_card_number").val().length > 4) {
			autoCompletePersonlData($("#racer_card_number").val());
		} else {
			$("#racer_card_number").addClass("card-not-found");
		}

	});

	$("#racer_card_number").bind("keyup focus", function( e ) {
		$("#racer_card_number").removeClass();
	});

	/*
	 * Team Selection
	 */
	$("#no_team").change(function() {
		displayTeamForm();
	});

	if ($("#nationality").val() == "IT") {
		$("#team_name_ita").prop("disabled", false);
		$("#team_name_non_ita").prop("disabled", true);
	}

	displayTeamForm();

	function displayTeamForm() {
		if ($("#no_team").is(":checked")) {
			$(".italian-team").css({ display: "none" });
			$(".non-italian-team").css({ display: "none" });

			$("#team_name_non_ita")
				.prop("disabled", true)
				.val("");
			$("#team_name_ita")
				.prop("disabled", true)
				.val("");
			$("#team_group").val("");
			$("#team_code").val("");
		} else if ($("#nationality").val() == "IT") {
			$("#team_name_non_ita").prop("disabled", true);
			$("#team_name_ita").prop("disabled", false);
			// $("#team_name_ita")
			// 	.autocomplete()
			// 	.setOptions({
			// 		params: {
			// 			team_nationality: $("#nationality").val()
			// 		}
			// 	});
			$(".italian-team").css({ display: "block" });
			$(".non-italian-team").css({ display: "none" });
		} else if ($("#nationality").val() == "") {
			$(".italian-team").css({ display: "none" });
			$(".non-italian-team").css({ display: "none" });
		} else {
			$(".italian-team").css({ display: "none" });
			$(".non-italian-team").css({ display: "block" });

			$("#team_name_ita").prop("disabled", true);
			$("#team_name_non_ita").prop("disabled", false);
		}
	}

	$("#nationality").on('change', function() {
		$("#team_name_ita").val("");
		$("#team_name_non_ita").val("");
		$("#team_code").val("");
		$("#team_group").val("");

		displayTeamForm();
	});

	$("#team_group").on('change', function() {
		$("#team_name_ita").val("");
		$("#team_code").val("");

		// $("#team_name_ita")
		// 	.autocomplete()
		// 	.setOptions({
		// 		params: {
		// 			team_group: $("#team_group").val()
		// 		}
		// 	});
	});

	$("#team_name_ita").autocomplete({
		// lookupLimit: 10,
		showNoSuggestionNotice: true,
		noSuggestionNotice: 'Nessun risultato trovato, inserisci nome e codice team manualmente.',
		minChars: 3,
		serviceUrl: APP_ROOT + "/api/" + LOCALE + "/v1/teams/search",

		transformResult: function(response) {
			return {
				suggestions: $.map(response.suggestions, function(dataItem) {
					return { value: dataItem.team_name, data: dataItem.team_code };
				})
			};
		},

		onSelect: function(suggestion) {
			$("#team_code").val(suggestion.data);
		},
		// onSearchComplete: function( query, suggestions ) {
		// 	if( suggestions.length == 0 ) {
		// 		$("#team_code").val("");
		// 	}
		// },
		onInvalidateSelection: function() {
			$("#team_code").val("");
		},
		preventBadQueries: false,
		dataType: "json",
		deferRequestBy: 300
	});

	$("#no-login-subscription").on('click', function() {
		$(".race-subscribe-steps-container .box")
			.first()
			.removeClass("subscriptions-box-closed");

		$("html, body").animate(
			{ scrollTop: $(".race-subscribe-steps-container").position().top },
			500
		);
	});

	$("input[name=medical_certificate]").on('change', function() {
		$("input[name=skip_medical_certificate]").prop("checked", false);
		$("#upload-certificate").attr("value", text_certificate);
	});

	$("input[name=skip_medical_certificate]").on('change', function() {
		
		var selected_val = $("input[name=skip_medical_certificate]:checked").val();

		if (selected_val == "skip_1") {
			$("#upload-certificate").attr("value", text_skip_certificate);
			$("input[name=medical_certificate]").val("");
		} else if (selected_val == "skip_2") {
			$("#upload-certificate").attr("value", text_skip_certificate);
			$("input[name=medical_certificate]").val("");
		} else if (selected_val == "skip_3") {
			$("#upload-certificate").attr("value", text_skip_certificate);
			$("input[name=medical_certificate]").val("");
		}

	});

	/*
	* Select subscription Fee
	*/

	if (
		$(".box-tickets--subscriptions").length &&
		$("#id_race_category").length
	) {
		$("#id_race_route").change(function() {
			filterSubscriptionTaxes();
		});

		$("#id_race_category").change(function() {
			filterSubscriptionTaxes();
		});

		function filterSubscriptionTaxes() {
			$("#quote-not-found").hide();
			$("#save-sub-fee").hide();
			$(".box-tickets--subscriptions").hide();
			var selected_route_id = $("#id_race_route").val();
			var selected_category_id = $("#id_race_category").val();
			var c = 0;
			$(".box-tickets--subscriptions .ticket").each(function() {
				if (
					selected_route_id != "" &&
					selected_category_id != "" &&
					($(this).data("id_race_route") == $("#id_race_route").val() ||
						$(this).data("id_race_route") == 0) &&
					($(this).data("id_race_category") == $("#id_race_category").val() ||
						$(this).data("id_race_category") == 0)
				) {
					$(this).css("display", "block");
					c++;
				} else {
					$(this).css("display", "none");
					$(this).removeClass("selected");
					$(this)
						.find("input")
						.prop("checked", "");
				}
			});
			if (!c && selected_route_id != "" && selected_category_id != "") {
				$(".box-tickets--subscriptions").hide();
				$("#quote-not-found .alert-box .text span").text("");
				var text =
					" " +
					text_no_quote.first +
					'<span class="bold"> ' +
					$("#id_race_route")
						.find("option:selected")
						.text() +
					"</span>" +
					text_no_quote.second +
					'<span class="bold">' +
					$("#id_race_category")
						.find("option:selected")
						.text() +
					"</span>";
				$("#quote-not-found .alert-box .text span").append(text);
				$("#quote-not-found").show();
			}
			if (c) {
				$(".box-tickets--subscriptions").fadeIn();
			}
		}

		filterSubscriptionTaxes();

		$(".box-tickets--subscriptions .ticket").click(function() {
			$(".ticket").removeClass("selected");
			$(this).addClass("selected");

			$(this)
				.find("input")
				.prop("checked", true);

			// Show custom fields section if it exists
			if ($("#custom-fields-container").length) {
				$("#custom-fields-container").fadeIn();
			}

			$("#save-sub-fee").fadeIn();
		});
	}

	/*
	 * Select payment method
	 */
	if ($(".payment-type-box").length > 0) {
		$(".payment-type-box input").click(function() {
			$(".payment-method-box").css("display", "none");
			if ($(this).is(":checked")) {
				$("#" + $(this).attr("id") + "-box").css("display", "block");
			}

			// Update price display for payment method fees
			updatePaymentMethodFee($(this).val());
		});
	}

	/*
	 * Satispay payment handling
	 */
	if ($("#payment_method_satispay").length > 0) {
		$("#satispay-confirm-button").click(function(e) {
			e.preventDefault();

			// Submit the form to satispayPay route
			var form = $('<form>', {
				'method': 'POST',
				'action': APP_ROOT + '/' + LOCALE + '/' + satispay_pay_route
			});

			// Add CSRF token
			form.append($('<input>', {
				'type': 'hidden',
				'name': '_token',
				'value': $('meta[name="csrf-token"]').attr('content')
			}));

			$('body').append(form);
			form.submit();
		});
	}

	function updatePaymentMethodFee(paymentMethod) {
		// This function can be used to dynamically update the total price
		// based on the selected payment method fee
		// Implementation depends on whether you want real-time price updates
	}

	/*
	 * Order summary
	 */

	// delete subscriber
	if ($(".order-summary-table").length > 0) {
		$(".delete-subscriber-from-order-butt").click(function(evt) {
			evt.preventDefault();

			$butt = $(this);

			swal({
				text:
					"Sicuro di voler cancellare l'iscrizione di " +
					$(this)
						.parents("tr")
						.find(".name-column")
						.html() +
					" " +
					$(this)
						.parents("tr")
						.find(".surname-column")
						.html(),
				buttons: {
					cancel: {
						text: "Cancel",
						value: false,
						visible: true,
						className: "",
						closeModal: true
					},
					confirm: {
						text: "OK",
						value: true,
						visible: true,
						className: "",
						closeModal: true
					}
				}
			}).then(function(confirm) {
				var id_subscription = $butt.parents("tr").data("id_subscription");
				console.log(id_subscription);

				if (confirm) {
					$.post(
						APP_ROOT +
							"/api/" +
							LOCALE +
							"/v1/race-manager/subscription/delete",
						{
							id_subscriptions: [id_subscription]
						},
						function(response) {
							$(".order-summary-table")
								.find('[data-id_subscription="' + id_subscription + '"]')
								.remove();
							location.reload(); // serve per aggiornare importo su payment intent stripe

							// $.post(
							// 	APP_ROOT + "/api/" + LOCALE + "/v1/subscriptions-order/get",
							// 	{
							// 		id_subscriptions_order: $(".order-summary-table").data(
							// 			"id_subscriptions_order"
							// 		)
							// 	},
							// 	function(subscriptions_order) {
							// 		$(".administration-fee").html(
							// 			subscriptions_order.administration_fee + " €"
							// 		);
							// 		$(".total-price").html(
							// 			subscriptions_order.total_to_pay + " €"
							// 		);
							// 		$(".clean-price").html(
							// 			subscriptions_order.clean_price + " €"
							// 		);
							// 	},
							// 	"json"
							// );
						},
						"json"
					);
				}
			});
		});
	}

	/*
	 * stripe
	 */

	if (typeof Stripe != "undefined") {

		var stripe = Stripe(stripe_pk);
		var elements = stripe.elements();

		var cardNumber = elements.create("cardNumber", {
			style: {
				base: {
					color: "#939393"
				}
			}
		});
		cardNumber.mount("#card-number");

		var cardExpiry = elements.create("cardExpiry", {
			style: {
				base: {
					color: "#939393"
				}
			}
		});
		cardExpiry.mount("#card-expiry");

		var cvc = elements.create("cardCvc", {
			style: {
				base: {
					color: "#939393"
				}
			}
		});
		cvc.mount("#card-cvc");

		var inputs = document.querySelectorAll("input.field");

		Array.prototype.forEach.call(inputs, function(input) {
			input.addEventListener("focus", function() {
				input.classList.add("is-focused");
			});
			input.addEventListener("blur", function() {
				input.classList.remove("is-focused");
			});
			input.addEventListener("keyup", function() {
				if (input.value.length === 0) {
					input.classList.add("is-empty");
				} else {
					input.classList.remove("is-empty");
				}
			});
		});

		document
			.querySelector(".stripe-form")
			.addEventListener("submit", function(e) {

				e.preventDefault();

				var cardholderName = document.getElementById('cardholder-name');
				var cardButton = document.getElementById('submit-stripe');
				var clientSecret = cardButton.dataset.secret;

				swal({
					title: swal_messages.payment_in_progress_dialog_title,
					text: swal_messages.payment_in_progress_dialog_text,
					buttons: false
				});

				$("#submit-stripe").prop("disabled", true);

				stripe.handleCardPayment(

					clientSecret, cardNumber, {
						payment_method_data: {
							billing_details: {name: cardholderName.value}
						}
					}

				).then(function(result) {

					if (result.error) {

						$("#submit-stripe").prop("disabled", false);
						swal({
							icon: "error",
							title: swal_messages.error_card,
							text: swal_messages.error_card_text
						});

					} else {

						if( result.paymentIntent.status == 'succeeded') {

							$.post(
								APP_ROOT + "/api/" + LOCALE + "/v1/subscribe/fulfill-order",
								{ id_subscriptions_order: $(".order-summary-table").data("id_subscriptions_order") },
								function(res) {
									if (!res.error_type) {
										window.location = res.route;
									} else {
										$("#submit-stripe").prop("disabled", false);
										swal({
											icon: "error",
											title: swal_messages.error_card,
											text: swal_messages.error_card_text
										});
									}
								}
							);

						}

						console.log('success')
						// window.location = res.route;

					}

				});

			});

	}

	/*
	 * Italian Tax Code (Codice Fiscale) validation - WARNING only
	 */
	function validateItalianTaxCode(taxCode) {
		// Basic format validation: 16 alphanumeric characters
		// Format: RSSMRA85T10A562S (6 letters + 2 digits + 1 letter + 2 digits + 1 letter + 3 digits + 1 letter)
		const taxCodeRegex = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i;

		if (!taxCode || taxCode.length === 0) {
			return { valid: true, message: '' }; // Empty is allowed, server will handle if required
		}

		taxCode = taxCode.toUpperCase().trim();

		if (!taxCodeRegex.test(taxCode)) {
			return {
				valid: false,
				message: LOCALE === 'it' ?
					'Il formato del Codice Fiscale non è corretto. Deve essere composto da 16 caratteri.' :
					'Tax Code format is incorrect. It must be 16 characters long.'
			};
		}

		// Additional validation: check control character (last digit)
		const evenMap = { '0': 0, '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9, 'A': 0, 'B': 1, 'C': 2, 'D': 3, 'E': 4, 'F': 5, 'G': 6, 'H': 7, 'I': 8, 'J': 9, 'K': 10, 'L': 11, 'M': 12, 'N': 13, 'O': 14, 'P': 15, 'Q': 16, 'R': 17, 'S': 18, 'T': 19, 'U': 20, 'V': 21, 'W': 22, 'X': 23, 'Y': 24, 'Z': 25 };
		const oddMap = { '0': 1, '1': 0, '2': 5, '3': 7, '4': 9, '5': 13, '6': 15, '7': 17, '8': 19, '9': 21, 'A': 1, 'B': 0, 'C': 5, 'D': 7, 'E': 9, 'F': 13, 'G': 15, 'H': 17, 'I': 19, 'J': 21, 'K': 2, 'L': 4, 'M': 18, 'N': 20, 'O': 11, 'P': 3, 'Q': 6, 'R': 8, 'S': 12, 'T': 14, 'U': 16, 'V': 10, 'W': 22, 'X': 25, 'Y': 24, 'Z': 23 };

		let sum = 0;
		for (let i = 0; i < 15; i++) {
			const char = taxCode.charAt(i);
			sum += i % 2 === 0 ? oddMap[char] : evenMap[char];
		}

		const expectedCheck = String.fromCharCode(65 + (sum % 26));
		const actualCheck = taxCode.charAt(15);

		if (expectedCheck !== actualCheck) {
			return {
				valid: false,
				message: LOCALE === 'it' ?
					'Il Codice Fiscale inserito non è valido. Verifica di aver inserito correttamente tutti i caratteri.' :
					'The entered Tax Code is not valid. Please verify you have entered all characters correctly.'
			};
		}

		return { valid: true, message: '' };
	}

	function showTaxCodeWarning(message) {
		$('#tax-code-warning-message').text(message);
		$('#tax-code-warning').slideDown(200);
	}

	function hideTaxCodeWarning() {
		$('#tax-code-warning').slideUp(200);
	}

	// Validate tax code when nationality changes or fiscal code is entered
	function checkTaxCodeValidation() {
		const nationality = $('#nationality').val();
		const taxCode = $('#fiscal_code').val();
		const requireTaxCode = $('#fiscal_code').data('require-tax-code') === 1;

		// Only validate if race requires tax code AND nationality is Italy
		if (requireTaxCode && (nationality === 'IT' || nationality === 'Italy')) {
			const validation = validateItalianTaxCode(taxCode);

			if (!validation.valid && taxCode.length > 0) {
				showTaxCodeWarning(validation.message);
			} else {
				hideTaxCodeWarning();
			}
		} else {
			hideTaxCodeWarning();
		}
	}

	// Attach event listeners
	$('#nationality').on('change', function() {
		checkTaxCodeValidation();
	});

	$('#fiscal_code').on('blur', function() {
		checkTaxCodeValidation();
	});

	$('#fiscal_code').on('input', function() {
		// Convert to uppercase as user types
		const cursorPos = this.selectionStart;
		this.value = this.value.toUpperCase();
		this.setSelectionRange(cursorPos, cursorPos);

		// Validate on input but with a small delay
		clearTimeout(window.taxCodeValidationTimeout);
		window.taxCodeValidationTimeout = setTimeout(function() {
			checkTaxCodeValidation();
		}, 500);
	});

	// Initial check on page load
	if ($('#fiscal_code').length > 0) {
		checkTaxCodeValidation();
	}

});
